import {Box, Flex, Image, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import ItemMessage from './ItemMessage'
import AvatarFullBodyImage from '@assets/images/learn/avatar_full_body.png'
import LoadingMessage from './LoadingMessage'
import './index.css'

const Format1 = ({
  isShowRestScreen,
  messages,
  suggestMessage,
  isLoadingUser,
  isLoadingBot,
  currentSentenceIndex,
  isDisableVolume,
}: {
  isShowRestScreen: any
  messages: any
  suggestMessage: any
  isLoadingUser: any
  isLoadingBot: any
  currentSentenceIndex: any
  isDisableVolume: any
}) => {
  return (
    <Box
      className="container-xl"
      flex={1}
      mb={{base: '20px', md: '40px'}}
      overflow={'auto'}
      scrollBehavior={'smooth'}>
      <Box
        className="scroll-bar"
        w={'100%'}
        h={'100%'}
        p={{base: '12px', md: '40px'}}
        scrollBehavior={'smooth'}
        overflow={'auto'}
        borderRadius={'40px'}
        bg={'white'}>
        {!isShowRestScreen ? (
          <>
            <Text
              textAlign={'center'}
              textTransform={'uppercase'}
              fontSize={'18px'}
              color={CommonColors.primary}>
              Hoàn thiện câu trả lời
            </Text>
            <Box>
              {messages?.map((item: any, index: any) => (
                <ItemMessage
                  key={index}
                  item={item}
                  isDisableVolume={isDisableVolume}
                />
              ))}
              {messages?.length === 1 && suggestMessage && !isLoadingUser && (
                <ItemMessage
                  item={suggestMessage}
                  isDisableVolume={isDisableVolume}
                />
              )}
              {isLoadingBot && <LoadingMessage type="bot" />}
              {isLoadingUser && <LoadingMessage type="user" />}
            </Box>
          </>
        ) : (
          <Flex justifyContent={'center'} h={'100%'}>
            <Flex>
              <Image src={AvatarFullBodyImage} mb={'-40px'} />
            </Flex>
            <Flex flexDirection={'column'}>
              <Box mt={'100px'}>
                <Text fontSize={'16px'} fontWeight={600}>
                  Perfect! Bạn đã học xong câu {currentSentenceIndex + 1}
                </Text>
                <Text fontSize={'24px'} fontWeight={600} maxW={'280px'}>
                  Giờ mình chuyển sang học{' '}
                  <Text as={'span'} color={'#FA8C16'}>
                    câu thứ {currentSentenceIndex + 2}
                  </Text>{' '}
                  nha!
                </Text>
              </Box>
            </Flex>
          </Flex>
        )}
      </Box>
    </Box>
  )
}

export default Format1
